module.exports = __webpack_public_path__ + "img/ill_badge_request_pickup.29b35d1d.svg";